import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import proctoringSessionsSlice from "./slices/proctoringSession";

export default function createStore({ onDataUpdated }: { onDataUpdated?: () => void }) {
	const store = configureStore({
		reducer: {
			[proctoringSessionsSlice.reducerPath]: proctoringSessionsSlice.reducer,
		},
		middleware: (getDefaultMiddleware) =>
			getDefaultMiddleware({ thunk: { extraArgument: { onDataUpdated } } }).concat(proctoringSessionsSlice.middleware),
	});
	setupListeners(store.dispatch);
	return store;
}

export type Store = ReturnType<typeof createStore>;
export type RootState = ReturnType<Store["getState"]>;
